import './WhoItsFor.css';

interface WhoItsForItem {
  title: string;
  description: string;
  image?: string;
}

const whoItsForData: WhoItsForItem[] = [
  {
    title: 'For Mums & Dads',
    description:
      "Finally see all those memories in one place. Watch your family's story unfold like the feature film it deserves to be.",
    image: '/video-for-mums-and-dads.jpg',
  },
  {
    title: 'For Grandparents',
    description:
      'Bridge the distance with family overseas. Relive the moments you were there for – and catch up on the ones you missed.',
    image: '/video-for-grandparents.jpg',
  },
  {
    title: 'For Milestone Celebrations',
    description:
      "Mother's Day. Father's Day. Wedding anniversaries. 21st birthdays. Graduations. Christmas. When words aren't enough, show them their story.",
    image: '/milestone-celebration-videos.jpg',
  },
  {
    title: 'For Your Children',
    description:
      "One day, they'll show this to their own kids. \"That's Mum when she was little. That's where we lived. That's the dog we had.\" You're not just preserving memories – you're creating heirlooms.",
    image: '/video-for-your-children.jpg',
  },
];

export default function WhoItsFor() {
  return (
    <section id="who-its-for" className="who-its-for section">
      <div className="container">
        <div className="who-its-for-header">
          <h2 className="who-its-for-title">
            <span className="who-its-for-title-line">Who It's For</span>
          </h2>
          <p className="who-its-for-subtitle">More Than a Gift. A Legacy.</p>
        </div>
        <div className="who-its-for-grid">
          {whoItsForData.map((item, index) => (
            <div key={index} className="who-its-for-card">
              <div className="who-its-for-card-image-wrapper">
                <div className="who-its-for-card-image">
                  {item.image ? (
                    <img src={item.image} alt={item.title} loading="lazy" />
                  ) : (
                    <div className="who-its-for-image-placeholder">
                      <svg
                        width="80"
                        height="80"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M4 16L8.586 11.414C9.367 10.633 10.633 10.633 11.414 11.414L16 16M14 14L15.586 12.414C16.367 11.633 17.633 11.633 18.414 12.414L20 14M14 8H14.01M6 20H18C19.105 20 20 19.105 20 18V6C20 4.895 19.105 4 18 4H6C4.895 4 4 4.895 4 6V18C4 19.105 4.895 20 6 20Z"
                          stroke="currentColor"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    </div>
                  )}
                </div>
                <div className="who-its-for-card-overlay"></div>
              </div>
              <div className="who-its-for-card-content">
                <h3 className="who-its-for-card-title">{item.title}</h3>
                <p className="who-its-for-card-description">{item.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
